import { Directive, ElementRef, HostListener, Input, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[coreTooltip]',
})
export class TooltipDirective implements OnDestroy {

  @Input() coreTooltip: string = '';
  @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';

  private tooltipElement: HTMLElement | null = null;
  private visible: boolean = false;
  private hideTimeout: any;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) { }

  @HostListener('mouseenter') onMouseEnter() {
    if (this.coreTooltip && !this.visible) {
      this.clearHideTimeout();
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.visible) {
      this.hide();
    }
  }

  private show() {
    this.createTooltip();
    this.setPosition();
    this.renderer.addClass(this.tooltipElement, 'tooltip-show');
    this.visible = true;
    
    this.addTooltipListeners();
  }

  private hide() {
    this.clearHideTimeout();
    
    if (this.tooltipElement) {
      this.renderer.removeClass(this.tooltipElement, 'tooltip-show');
      
      // Animasyon bittikten sonra kaldır
      this.hideTimeout = setTimeout(() => {
        if (this.tooltipElement && !this.visible) {
          this.removeTooltipListeners();
          this.renderer.removeChild(document.body, this.tooltipElement);
          this.tooltipElement = null;
        }
      }, 200);
    }
    this.visible = false;
  }

  private addTooltipListeners() {
    if (!this.tooltipElement) return;
    
    // Tooltip üzerine gelince kapatmayı geciktir
    this.tooltipElement.addEventListener('mouseenter', this.onTooltipEnter);
    this.tooltipElement.addEventListener('mouseleave', this.onTooltipLeave);
  }

  private removeTooltipListeners() {
    if (!this.tooltipElement) return;
    
    this.tooltipElement.removeEventListener('mouseenter', this.onTooltipEnter);
    this.tooltipElement.removeEventListener('mouseleave', this.onTooltipLeave);
  }

  private onTooltipEnter = () => {
    this.clearHideTimeout(); // Kapatma işlemini iptal et
  }

  private onTooltipLeave = () => {
    this.hide(); // Tooltip'ten ayrılınca kapat
  }

  private clearHideTimeout() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  private createTooltip() {
    if (this.tooltipElement) return;

    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltipElement, 'core-tooltip');
    this.renderer.addClass(this.tooltipElement, `tooltip-${this.tooltipPosition}`);
    
    const tooltipText = this.renderer.createText(this.coreTooltip);
    this.renderer.appendChild(this.tooltipElement, tooltipText);
    
    this.renderer.appendChild(document.body, this.tooltipElement);
  }

  private setPosition() {
    if (!this.tooltipElement) return;

    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltipElement.getBoundingClientRect();
    const scrollPos = window.scrollY || document.documentElement.scrollTop;

    let top, left;

    switch (this.tooltipPosition) {
      case 'top':
        top = hostPos.top - tooltipPos.height - 10;
        left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        break;
      case 'bottom':
        top = hostPos.bottom + 10;
        left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        break;
      case 'left':
        top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
        left = hostPos.left - tooltipPos.width - 10;
        break;
      case 'right':
        top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
        left = hostPos.right + 10;
        break;
    }

    this.renderer.setStyle(this.tooltipElement, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
  }

  ngOnDestroy() {
    // Component destroy olunca temizlik
    this.clearHideTimeout();
    this.removeTooltipListeners();
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}